/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import PersonalEmailActionTaken from "./PersonalEmailActionTaken"
import AddEditEmailAddress from "./AddEditEmailAddress"
import useEmailVerification from "./useEmailVerification"
import { useIntl } from "react-intl"
import EmployeeOnlyModalContainer from "../employee-only-containers/EmployeeOnlyModalContainer"
import { Modal } from "@carrotfertility/carotene"

type AddEditEmailAddressModalProps = {
  open: boolean
  onClose: () => void
  showEmailUpdated: boolean
  showEmailRemoved: boolean
  removeDisabled: boolean
  setShowEmailUpdated: (boolean) => void
  setRemoveDisabled: (boolean) => void
  setShowEmailRemoved: (boolean) => void
}

export default function EditEmailAddressModal({
  open,
  onClose,
  showEmailUpdated,
  setShowEmailUpdated,
  showEmailRemoved,
  setRemoveDisabled,
  setShowEmailRemoved,
  removeDisabled
}: AddEditEmailAddressModalProps): JSX.Element {
  const { removePersonalEmail } = useEmailVerification()
  const intl = useIntl()

  async function onRemove(event) {
    event.preventDefault()
    setRemoveDisabled(true)
    await removePersonalEmail()
    setShowEmailRemoved(true)
    setShowEmailUpdated(true)
  }

  return (
    <EmployeeOnlyModalContainer onClose={onClose} open={open}>
      <Modal open={open} onClose={onClose} showClose={!showEmailUpdated}>
        {showEmailUpdated ? (
          <PersonalEmailActionTaken
            header={
              showEmailRemoved
                ? intl.formatMessage({ defaultMessage: "Email address removed" })
                : intl.formatMessage({ defaultMessage: "Email address changed" })
            }
            body={
              showEmailRemoved
                ? intl.formatMessage({ defaultMessage: "This email address was successfully removed." })
                : intl.formatMessage({
                    defaultMessage:
                      "Please check your inbox and click the verification link to enable us to communicate with you at this address."
                  })
            }
            image={showEmailRemoved ? "illo-envelope-minus" : "illo-envelope-plus"}
            onClose={onClose}
          />
        ) : (
          <AddEditEmailAddress
            setShowActionTaken={setShowEmailUpdated}
            title={intl.formatMessage({ defaultMessage: "Edit email address" })}
            showRemoveEmail={true}
            onRemove={onRemove}
            removeDisabled={removeDisabled}
          />
        )}
      </Modal>
    </EmployeeOnlyModalContainer>
  )
}
